import React from 'react';
import ReactDOM from 'react-dom/client';
import PortalCompras from './PortalCompras';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><PortalCompras /></React.StrictMode>);
